import { Box, Card, CardContent, Theme, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    "& ul": {
      margin: 0,
      paddingLeft: 26,
      "& > li": {
        fontSize: 16,
        lineHeight: "23.33px",
        letterSpacing: 0.5,
        fontWeight: 400,
        fontFamily: "'Futura Allele', sans-serif",
      },
    },
    "& > ul": {
      listStyleType: "disc",

      "& ul": {
        listStyleType: "circle",
      },
    },
  },
  title: {
    letterSpacing: 0.25,
  },
  formatImage: {
    position: "relative",
    overflow: "hidden",
    margin: 0,
    height: 140,

    "& > img": {
      position: "absolute",
      left: 0,
      top: 0,
    },
  },
}));

const Requirements = () => {
  const classes = useStyles();

  return (
    <Card>
      <CardContent>
        <Box
          display="flex"
          flexDirection="column"
          gap="16px"
          className={classes.content}
        >
          <Typography variant="h2" className={classes.title}>
            Requirements
          </Typography>
          <ul>
            <li>Uploaded file must have a .zip file format</li>
            <li>
              Uploaded file must contain one folder per design, each with
              subdirectory named &ldquo;
              <Typography component="code" color="primary">
                &#123;design_id&#125;
              </Typography>
              &rdquo;
            </li>
            <li>
              Each subdirectory must contain each of the following files:
              <ul>
                <li>
                  YAML: file name is &ldquo;
                  <Typography component="code" color="primary">
                    &#123;design_id&#125;.yaml
                  </Typography>
                  &rdquo;
                </li>
                <li>
                  CTF: file name is &ldquo;
                  <Typography component="code" color="primary">
                    &#123;design_id&#125;.ctf
                  </Typography>
                  &rdquo;
                </li>
                <li>
                  GTF: file name is &ldquo;
                  <Typography component="code" color="primary">
                    &#123;design_id&#125;.gtf
                  </Typography>
                  &rdquo; OR &ldquo;
                  <Typography component="code" color="primary">
                    &#123;design_id&#125;_cnv.gtf
                  </Typography>
                  &rdquo; + &ldquo;
                  <Typography component="code" color="primary">
                    &#123;design_id&#125;_nocnv.gtf
                  </Typography>
                  &rdquo;
                </li>
                <li>
                  BED: file name is &ldquo;
                  <Typography component="code" color="primary">
                    &#123;design_id&#125;.bed
                  </Typography>
                  &rdquo;
                </li>
                <li>
                  CSV: file name is &ldquo;
                  <Typography component="code" color="primary">
                    &#123;design_id&#125;_details.csv
                  </Typography>
                  &rdquo;
                </li>
              </ul>
            </li>
          </ul>
          <ul>
            <li>
              Do not leave or reload this page until validation is complete.
            </li>
            <li>
              If a validation error occurs, please revise and upload the entire
              file again.
            </li>
            <li>
              Design catalog will only be updated once Admin selects Approve /
              Upload Designs
            </li>
          </ul>
        </Box>
      </CardContent>
    </Card>
  );
};

export default Requirements;
